// src/components/app/RouteLoading.jsx
// Loading skeleton for lazy-loaded routes
import React from 'react';

export default function RouteLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0b12] text-white">
      <div className="text-center">
        <div className="inline-block w-12 h-12 border-4 border-white/20 border-t-fuchsia-600 rounded-full animate-spin mb-4"></div>
        <p className="text-lg text-white/70">Loading...</p>
      </div>
    </div>
  );
}
